import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const http = axios.create({ baseURL: API });

// Admin axios — auto-attaches Bearer token, redirects on 401
export const adminHttp = axios.create({ baseURL: API });
adminHttp.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("azefac_admin_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});
adminHttp.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      localStorage.removeItem("azefac_admin_token");
      if (window.location.pathname.startsWith("/admin") && window.location.pathname !== "/admin/login") {
        window.location.href = "/admin/login";
      }
    }
    return Promise.reject(err);
  }
);

// Public
export const fetchProperties = (params = {}) =>
  http.get("/properties", { params }).then((r) => r.data);
export const fetchProperty = (slug) =>
  http.get(`/properties/${slug}`).then((r) => r.data);
export const fetchBlogs = (limit = 12) =>
  http.get("/blogs", { params: { limit } }).then((r) => r.data);
export const fetchMarket = () =>
  http.get("/market-insights").then((r) => r.data);
export const submitContact = (payload) =>
  http.post("/contact", payload).then((r) => r.data);

// Build a fully-qualified URL for a stored image path returned by /admin/upload (e.g. "/api/files/...")
export const resolveImageUrl = (url) => {
  if (!url) return "";
  if (url.startsWith("http")) return url;
  if (url.startsWith("/api/")) return `${BACKEND_URL}${url}`;
  return url;
};
